export { StudentSettingsAddressPage } from "./StudentSettingsAddressPage"
export type {
    StudentAddressSettingsField,
    StudentSettingsAddressPageProps,
    UIStudentAddressSettings,
} from "./StudentSettingsAddressPage"
